import { useState, useCallback } from 'react';

import { SelectedUserStatusesEnum } from '../constants';
import { SelectedUser } from '../types';

import { UserModel } from 'v2/types/UserModel';

export const useSelectedUsers = () => {
  const [selectedUsers, setSelectedUsers] = useState<SelectedUser[]>([]);

  const addUser = useCallback(
    (user: UserModel) => {
      const isAlreadySelected = selectedUsers.some((selectedUser) => selectedUser.id === user.id);

      if (!isAlreadySelected) {
        setSelectedUsers((prev) => [
          ...prev,
          {
            id: user.id,
            username: user.userNickname,
            telegramUserName: user.telegramUserName,
            status: SelectedUserStatusesEnum.PENDING,
          },
        ]);
      }
    },
    [selectedUsers]
  );

  const addUsers = useCallback((users: SelectedUser[]) => {
    setSelectedUsers((prev) => [...prev, ...users]);
  }, []);

  const removeUser = useCallback((userId: string) => {
    setSelectedUsers((prev) => prev.filter((user) => user.id !== userId));
  }, []);

  const updateUserStatus = useCallback((userId: string, status: SelectedUserStatusesEnum, errorMessage?: string) => {
    setSelectedUsers((prev) => prev.map((user) => (user.id === userId ? { ...user, status, errorMessage } : user)));
  }, []);

  const resetAllStatuses = useCallback((status: SelectedUserStatusesEnum = SelectedUserStatusesEnum.PENDING) => {
    setSelectedUsers((prev) => prev.map((user) => ({ ...user, status, errorMessage: undefined })));
  }, []);

  const clearUsers = useCallback(() => {
    setSelectedUsers([]);
  }, []);

  return {
    selectedUsers,
    addUser,
    addUsers,
    removeUser,
    updateUserStatus,
    resetAllStatuses,
    clearUsers,
  };
};
